// Сортировка колонок
export function sortColumnsByOrder(order, columns) {
    // Создаём быстродоступную мапу: имя → индекс в order
    const indexMap = order.reduce((map, name, i) => {
        map[name] = i;
        return map;
    }, {});

    // Возвращаем копию columns, отсортированную по нашим индексам
    return [...columns].sort((a, b) => {
        const ia = indexMap[a.name] ?? Infinity;
        const ib = indexMap[b.name] ?? Infinity;
        return ia - ib;
    });
}